var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 30,
    viewBox: "0 0 45 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Credit Card"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Credit Card_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M38.7215 0.164062H6.41662C3.08332 0.164062 0.371094 2.63088 0.371094 5.66308V23.8438C0.371094 26.8752 3.08285 29.3421 6.41662 29.3421H38.722C42.0553 29.3421 44.7675 26.8752 44.7675 23.8438V5.66308C44.7668 2.6309 42.0552 0.164062 38.7215 0.164062ZM41.3581 23.8436C41.3581 24.9958 40.1752 25.9332 38.7215 25.9332H6.41662C4.9627 25.9332 3.77986 24.9964 3.77986 23.8436V11.8993H41.3581V23.8436ZM41.3581 8.49055H3.7798V5.66242C3.7798 4.51026 4.96264 3.57237 6.41656 3.57237H38.722C40.1759 3.57237 41.3587 4.50978 41.3587 5.66242V8.49057L41.3581 8.49055Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.1244 18.1641H6.875V21.5728H13.1244V18.1641Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M20.3861 18.1641H14.1367V21.5728H20.3861V18.1641Z",
    fill: "black"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/CreditCard.5a893eb80e745995d2cd9e10a2b89b26.svg";
export { ForwardRef as ReactComponent };